import React from "react";
import Section from "@/Molecules/Section";
import ThreeColumn from "@/Molecules/TheeColumn/ThreeColumn";
import { columnsLabel, money } from "@/helpers/landingFormat";
import { LandingProps } from "@/types/Landing";

/**
 * Price, deadlines and formats of the paper
 */
const LandingFacts = ({paper, priceFrom, schedule, format}: Pick<LandingProps, 'paper' | 'priceFrom' | 'schedule' | 'format'>) =>
  <Section
    lighter
    center
    title={`Tarieven, deadlines en formaten van ${paper.title}`}
    subtitle={paper.releases}
  >
    <ThreeColumn stretch columns={[
      <>
        <h3>Tarief</h3>
        {priceFrom
          ? <p>
            Vanaf <strong>€ {money(priceFrom.price)}</strong> incl. btw voor {columnsLabel(priceFrom.columns)}
            {priceFrom.width && <> ({priceFrom.width} mm breed)</>} × {priceFrom.height} mm in zwart-wit.
          </p>
          : <p>Je ziet de exacte prijs direct tijdens het opmaken.</p>}
        {format.color && <p>{format.color}.</p>}
      </>,
      <>
        <h3>Deadlines</h3>
        <table className={'mx-auto text-left'}>
          <thead>
          <tr>
            <th className={'pr-4'}>Plaatsing</th>
            <th>Aanleveren vóór</th>
          </tr>
          </thead>
          <tbody>
          {schedule.map((row) => <tr key={row.day}>
            <td className={'pr-4 capitalize'}>{row.day}</td>
            <td>{row.deadlineDay} {row.deadlineTime}</td>
          </tr>)}
          </tbody>
        </table>
      </>,
      <>
        <h3>Formaten</h3>
        <p>Breedte: {format.columns.map((column) => `${columnsLabel(column.columns)} (${column.width} mm)`).join(', ')}.</p>
        <p>
          Hoogte: {format.isBlock
          ? format.blocks.map((block) => `${block.height} mm`).join(', ')
          : `${format.minHeight} tot ${format.maxHeight} mm`}.
        </p>
        {paper.editions.length > 0 && <p>Te plaatsen in de volledige oplage of in de edities {paper.editions.join(', ')}.</p>}
      </>,
    ]} />
  </Section>;

export default LandingFacts;
